import { render } from "./NoMatch.vue?vue&type=template&id=53dcfc30"
const script = {}
script.render = render

export default script